import { queryOptions } from "@tanstack/react-query";
import { parseResponse, type InferResponseType } from "hono/client";

import { client } from "~/lib/api";

export type Customer = InferResponseType<
  typeof client.portal.customers.$get,
  200
>[number];

export const customersQueryOptions = () =>
  queryOptions({
    queryKey: ["portal", "customers"] as const,
    queryFn: () => parseResponse(client.portal.customers.$get()),
  });
